export default "__VITE_ASSET__CFtm3Kyw__"